<template>
  <div class="card py-2 px-3 mb-1">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div
          style="font-weight:600"
        >{{assessment.firstName}} {{assessment.lastName}} - Tutor: {{assessment.tutorFirstName}} {{assessment.tutorLastName}}</div>
        <div>
          <span class="mr-2" style="text-transform: capitalize">Subject: {{assessment.subject}}</span>
          Year Level: {{assessment.yearLevel || 'Prep'}}
        </div>
      </div>
      <a
        :href="'/dashboard/create-assessment?id=' + assessment._id"
        style="font-weight:  600"
        v-if="!assessment.tutorSubmittedAt"
      >EDIT</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["assessment"]
};
</script>

<style>
</style>
